const TYPES = {
    PDF_EXPORT_ERROR: 'PDF_EXPORT_ERROR',
    CSV_EXPORT_ERROR: 'CSV_EXPORT_ERROR'
};

export const PDFExportError = (error: Error) => ({
    type: TYPES.PDF_EXPORT_ERROR,
    payload: error
});

export const CSVExportError = (error: Error) => ({
    type: TYPES.CSV_EXPORT_ERROR,
    payload: error
});

export default {
    TYPES,
    PDFExportError,
    CSVExportError
};
